<template>
  <L1Vue :label="project.projectName" v-if="project">
    <template slot="slot_title">

      <div :style="{marginInline: 'auto'}"></div>
      <a v-if="project&&page==='預訂統計'" class="roundbtn" :href="`${VUE_APP_BASE_URL}/webapi/projects/excel/${project._id}?${query}`" target="__blank"><div></div>匯出</a>
      <RT :options="project.actived ? ['預訂統計', '導購紀錄', '基本設定', '餐點|商品設定']: ['基本設定', '餐點|商品設定']" :defaultValue="page" @input="$router.replace({ name, params, query: { page: $event } })"></RT>
    </template>
    <template v-if="project">
      <ReportVue v-if="page==='預訂統計'" :project="project" :report="report" :total="total" :range="range"
      :count="count" :xAxis="xAxis" :series="series" :yAxis="yAxis" :chartType="chartType"
      @updateMode="chartType=$event"/>
      <FastRecordVue v-else-if="page==='導購紀錄'" :project="project"/>
      <ProductsVue v-else-if="page==='餐點|商品設定'" :project="project" :categories="categories" @refresh="getProject"/>
      <BaseVue v-else :project="project" @refresh="getProject" :salesmans="salesmans"/>
    </template>
  </L1Vue>
</template>

<script>
import { getapi } from '../../store/fetch'
import L1Vue from './setting/L1.vue'
import BaseVue from './setting/base.vue'
import ReportVue from './report/index.vue'
import ProductsVue from './setting/Products.vue'
import FastRecordVue from './FastRecord.vue'
const VUE_APP_BASE_URL = process.env.VUE_APP_BASE_URL
export default {
  components: { L1Vue, BaseVue, ReportVue, ProductsVue, FastRecordVue },
  data () {
    return {
      VUE_APP_BASE_URL,
      chartType: 'createTime',
      project: null,
      report: null,
      count: 0,
      total: null,
      series: [],
      xAxis: [],
      yAxis: [],
      categories: [],
      salesmans: [],
      range: { start: this.moment().startOf('month').format('YYYY-MM-DD'), end: this.moment().endOf('month').format('YYYY-MM-DD') }
    }
  },
  computed: {
    name () { return this.$route.name },
    params () { return this.$route.params },
    page () {
      return this.$route.query.page
    },
    query () {
      return new URLSearchParams({
        start: this.moment(this.range.start).startOf('day').toISOString(),
        duration: this.moment(this.range.end).diff(this.moment(this.range.start), 'day')
      })
    }
  },
  watch: {
    page: {
      immediate: true,
      async handler () {
        if (this.page === '預訂統計') {
          await this.getReport(this.chartType)
        }
      }
    },
    async chartType () {
      await this.getReport(this.chartType)
    }
  },
  async mounted () {
    await this.getProject()
    const salesmans = await getapi('users/local/short')
    this.salesmans = salesmans
    this.categories = await getapi('rest_product/category/all')
  },
  methods: {
    async getProject () {
      const data = await getapi(`projects/${this.$route.params.id}`)
      this.project = data
    },
    async getReport (key) {
      const data = await getapi(`projects/report/${key}/${this.$route.params.id}?${new URLSearchParams({
        start: this.moment(this.range.start).startOf('day').toISOString(),
        duration: this.moment(this.range.end).diff(this.moment(this.range.start), 'day')
      })}`)
      this.report = data.summary
      this.count = data.count
      this.total = data.total
      this.series = data.series
      this.xAxis = data.xAxis
      this.yAxis = data.yAxis
    }
  }
}
</script>

<style lang="scss" scoped>
.roundbtn {
  background-color: var(--color-checked);
  height: 50px;
  width: 120px;
  color: #FFFFFF;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  border-radius: 25px;
  gap: 10px;
  &>div {
    width: 26px;
    height: 26px;
    background-color: #FFFFFF;
    mask-image: url(/svg/btn/excel1.svg);
  }
}
</style>
